import { createFileRoute, redirect } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/tow-guide")({
  head: () => pageHead({ title: 'RV Tow Guide', description: 'Find out what your vehicle can tow with the Rex & Sons RVs tow guide and matching tool.', path: '/tow-guide' }),
  beforeLoad: () => {
    throw redirect({ href: "/tow-guides" });
  },
});
